module.exports = __webpack_public_path__ + "logo2x.bb745b1cde40091cb1cb.png";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/layout/images/logo2x.png
// module id = ../../../../../src/assets/layout/images/logo2x.png
// module chunks = 2